import {
  AUTHENTICATE_USER,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT,
  GET_USER_DATA_REQUESTED,
  GET_USER_DATA_SUCCEEDED,
  GET_USER_DATA_FAILED,
  UPDATE_USER_DATA,
} from './actionTypes';

export function authenticateUser(token) {
  return {
    type: AUTHENTICATE_USER,
    token,
  };
}

export function userLogoutRequest() {
  return {
    type: USER_LOGOUT_REQUEST,
  };
}

export function userLogout() {
  return {
    type: USER_LOGOUT,
  };
}

export function getUserDataRequested() {
  return {
    type: GET_USER_DATA_REQUESTED,
  };
}

export function getUserDataSucceeded(userData) {
  return {
    type: GET_USER_DATA_SUCCEEDED,
    userData,
  };
}

export function getUserDataFailed(err) {
  return {
    type: GET_USER_DATA_FAILED,
    err,
  };
}

export function updateUserData(updateData) {
  return {
    type: UPDATE_USER_DATA,
    payload: {
      updateData,
    },
  };
}



// WEBPACK FOOTER //
// ./src/services/user/action.js